import { useState } from "react";
import { useInvitation } from "../../../contexts/InvitationContext";
import {
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from "../../../design/dropdown";
import {
  ArrowRightStartOnRectangleIcon,
  BellAlertIcon,
  LightBulbIcon,
  ShieldCheckIcon,
  UserCircleIcon,
} from "@heroicons/react/20/solid";
import { Badge } from "../../../design/badge";
import { DocumentIcon, UsersIcon } from "@heroicons/react/16/solid";
import NotificationsDialog from "../../NotificationsDialog";
import InvitationsDialog from "../../Dialogs/InvitationsDialog/InvitationsDialog";
import { signOut } from "firebase/auth";
import { auth } from "../../../firebase";

export const AccountDropdownMenu = ({
  anchor,
}: {
  anchor: "top start" | "bottom end";
}) => {
  const { invitations } = useInvitation();
  const [isNotificationsDialogOpen, setNotificationsDialogOpen] =
    useState(false);
  const [isInvitationsDialogOpen, setInvitationsDialogOpen] = useState(false);

  const pendingInvitationCount = invitations.filter(
    (invitation) => invitation.status === "pending",
  ).length;

  return (
    <>
      <DropdownMenu className="min-w-64" anchor={anchor}>
        <DropdownItem href="/settings">
          <UserCircleIcon />
          <DropdownLabel>My account</DropdownLabel>
        </DropdownItem>
        <DropdownItem onClick={() => setNotificationsDialogOpen(true)}>
          <BellAlertIcon />
          <DropdownLabel>Notifications</DropdownLabel>
        </DropdownItem>
        <DropdownItem onClick={() => setInvitationsDialogOpen(true)}>
          <UsersIcon />
          <DropdownLabel>Invitations</DropdownLabel>
          {pendingInvitationCount > 0 && (
            <Badge color="red">{pendingInvitationCount}</Badge>
          )}
        </DropdownItem>
        <DropdownDivider />
        <DropdownItem href="https://www.visitproof.com/privacy-policy">
          <ShieldCheckIcon />
          <DropdownLabel>Privacy policy</DropdownLabel>
        </DropdownItem>
        <DropdownItem href="https://www.visitproof.com/terms-of-service">
          <DocumentIcon />
          <DropdownLabel>Terms of Service</DropdownLabel>
        </DropdownItem>
        <DropdownItem href="mailto:info@casetime.com">
          <LightBulbIcon />
          <DropdownLabel>Share feedback</DropdownLabel>
        </DropdownItem>
        <DropdownDivider />
        <DropdownItem
          onClick={async () => {
            await signOut(auth);
          }}
        >
          <ArrowRightStartOnRectangleIcon />
          <DropdownLabel>Sign out</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
      <NotificationsDialog
        isOpen={isNotificationsDialogOpen}
        onClose={() => setNotificationsDialogOpen(false)}
      />
      <InvitationsDialog
        isOpen={isInvitationsDialogOpen}
        onClose={() => setInvitationsDialogOpen(false)}
      />
    </>
  );
};
